import BaseModel from '../base/BaseModel.model';
export default class TermCondiction extends BaseModel {
    
    public title?: string; 
    public description?: string;
    public termCondictionId?:number = 0; 
    constructor(){
        super();
        this.init();
    }

    init(){
        this.termCondictionId =0;
        this.title = "";
        this.description ="";
    }
}